($ => {


    function setPriceValue(element, price) {
        for (var i = 0; i < element.childNodes.length; i++) {
            if (element.childNodes[i].className == 'currency-value') {
                element.childNodes[i].textContent = ''+price+''
                break
            }
        }
    }


    function refreshPrice() {
        var discountCodeCount = Number($('#d_order_discountCodeCount').val())
        if (discountCodeCount < 1) {
            $('#d_order_discountCodeCount').val(1)
            discountCodeCount = 1
        }
        var itemPrice = document.getElementById("itemPrice")

        var itemValue = itemPrice.getAttribute('data-regular-price')
        setPriceValue(itemPrice, itemValue)

        var totalPriceValue = itemValue * discountCodeCount
        setPriceValue(document.getElementById("totalPrice"), totalPriceValue)
    }


    $('.AmountSelector-increase').click(function (event) {
        let component = event.target.closest('.AmountSelector'),
            element = $(component).find('input'),
            value = element.val()

        let newValue = Number(value) + 1
        element.val(newValue)
        refreshPrice()
    })

    $('.AmountSelector-decrease').click(function (event) {
        let component = event.target.closest('.AmountSelector'),
            element = $(component).find('input'),
            value = element.val()

        if (value > 1) {
            let newValue = Number(value) - 1
            element.val(newValue)
            refreshPrice()
        }
    })


    $('#d_order_discountCodeCount').change(refreshPrice)


})(jQuery)
